import { createContext, useState, useContext, type ReactNode } from 'react';

interface StreamingContextType {
	isStreaming: boolean;
	setIsStreaming: (isStreaming: boolean) => void;
}

const StreamingContext = createContext<StreamingContextType | undefined>(undefined);

export const StreamingProvider = ({ children }: { children: ReactNode }) => {
	const [isStreaming, setIsStreaming] = useState(false);

	return (
		<StreamingContext.Provider value={{ isStreaming, setIsStreaming }}>
			{children}
		</StreamingContext.Provider>
	);
};

export const useStreaming = () => {
	const context = useContext(StreamingContext);
	if (context === undefined) {
		throw new Error('useStreaming must be used within a StreamingProvider');
	}
	return context;
};
